import React from 'react';

// Switch acessível reutilizável — usado tanto nas linhas de enquete
// dinâmica (visibilidade) quanto no acordeão de enquetes legadas.
const ToggleSwitch = ({ ativo, onChange, disabled, label }) => (
  <button
    type="button"
    role="switch"
    aria-checked={ativo}
    aria-label={label}
    disabled={disabled}
    onClick={() => onChange(!ativo)}
    className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${
      ativo ? 'bg-emerald-500' : 'bg-gray-300'
    }`}
  >
    <span
      className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform duration-200 ${
        ativo ? 'translate-x-6' : 'translate-x-1'
      }`}
    />
  </button>
);

export default ToggleSwitch;
